import { getApi } from '../../../utils/api'
import { DOC_FLOW_API_URL } from '../DocFlow.constants'

export function getRecipients({ documentId, ...restParams }) {
  return getApi({
    endpoint: `${DOC_FLOW_API_URL}${documentId}/available-recipients-for-combining/`,
    params: restParams,
  })
}
